// extracted by mini-css-extract-plugin
export var sliderRange = "_pq-2";
export var sliderRoot = "_pq-0";
export var sliderThumb = "_pq-3";
export var sliderTrack = "_pq-1";